globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

/* All plugins are implemented in /commons/limitless_plugins */
appCustomerSpace.LimitlessPlugins.initPlugins = function($html)
{
  $html = $html || $('body');

  appCustomerSpace.LimitlessPlugins.Checkbox.init($html);
  appCustomerSpace.LimitlessPlugins.Radio.init($html);
  appCustomerSpace.LimitlessPlugins.DatePickers.Single.init($html);
  appCustomerSpace.LimitlessPlugins.TimePickers.Single.init($html);
  appCustomerSpace.LimitlessPlugins.ColorPickers.Hex.init($html);
  appCustomerSpace.LimitlessPlugins.Slider.init($html);
  appCustomerSpace.LimitlessPlugins.Selects.Single.init($html);
  appCustomerSpace.LimitlessPlugins.Selects.Multiple.init($html);
  appCustomerSpace.LimitlessPlugins.Switch.init($html);
  appCustomerSpace.LimitlessPlugins.BootstrapSwitch.init($html);
  appCustomerSpace.LimitlessPlugins.Tooltip.init($html);
  appCustomerSpace.LimitlessPlugins.Dropdown.init($html);
  appCustomerSpace.LimitlessPlugins.DataTable.initAll($html);
  appCustomerSpace.LimitlessPlugins.FancyBox.initAll($html);
}
